module.exports = {
      id: "logout-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#logout",
      toString: function () {
        return this.url;
      }
    }